import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinStock from '@/mixins/stock'
import MixinPlayer from '@/mixins/player'
import { StockMolecule } from '@interfaces/stock'
import { vageDragEvents, VageDrag, VageDragEvent } from '@/plugins/drag/manager'
import ModelMolecule from '@/models/molecule'
import { playerColors } from '@/constants/player'
import { uuid } from '@/shared/utils'

interface PawnStyle {
  top?: number
  left?: number
  position?: string
  pointerEvents?: string
}

@Component
export default class Pawns extends mixins(MixinStock, MixinPlayer) {
  private pawnElement: HTMLElement

  get className(): string {
    return playerColors[this.activePlayer.teamID][this.activePlayer.type]
  }

  public get amount() {
    return this.activePlayer.pawnAmount
  }

  public mounted() {
    this.init()
  }

  public init() {
    this.initVariables()
    this.bindEvents()
  }

  public onDrop(event: VageDragEvent) {
    const { x, y } = event
    const element: Element | null = document.elementFromPoint(x, y)

    if (!element) {
      return
    }

    if (this.activePlayer.pawnAmount <= 0) {
      return
    }

    const molecule: HTMLElement | null = element.closest('.molecule') as HTMLElement

    if (molecule) {
      const modelMolecule: ModelMolecule = this.$molecules.find(molecule.dataset.id as string)

      if (this.stockHasMolecule(modelMolecule)) {
        if (modelMolecule.id === '1oxv7zxd') {
          this.$modal.open('choose-fat')
        } else {
          const stockMolecule: StockMolecule = this.stockGetMolecule(modelMolecule)

          this.storeAddPawn({
            id: uuid(),
            molecule: modelMolecule,
            player: this.activePlayer,
            team: this.activeTeam,
            chainLengths: stockMolecule.chainLengths,
            doubleBindings: stockMolecule.doubleBindings,
          })

          this.storeUpdatePawnAmount({
            player: this.activePlayer,
            amount: -1,
          })

          this.stockRemoveMolecule(modelMolecule, stockMolecule.chainLengths)
        }
      }
    }
  }

  private initVariables() {
    this.pawnElement = this.$refs.pawn as HTMLElement
  }

  private bindEvents() {
    const vageDrag: VageDrag = this.$drag.add(this.pawnElement, {})

    vageDrag.on(vageDragEvents.DROP, this.onDrop)
  }
}
